import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";

import { KNOWN_TRAVELER_NUMBER_SCHEMA_FIELD_NAME } from "./KnownTravelerNumberFormField.schema";

/**
 * KnownTravelerNumberFormField facilitates populating or updating the Known Traveler Number.
 */

export const KnownTravelerNumberFormField = (props) => {
  const {
    componentProps,
    description = i18n("KnownTravelerNumberFormField__OPTIONAL"),
    disabled,
    name = KNOWN_TRAVELER_NUMBER_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("KnownTravelerNumberFormField__ARIA"),
        ...componentProps,
      },
      description,
      disabled,
      label: i18n("KnownTravelerNumberFormField__LABEL"),
      labelInformationTipProps: {
        "aria-label": i18n(
          "KnownTravelerNumberFormField__INFO_TIP_ARIA",
          i18n("KnownTravelerNumberFormField__LABEL")
        ),
        content: <PlacementFactory id="tooltipKTN" />,
        location: "below",
        size: "small",
      },
      name: name,
    };
  }
};

KnownTravelerNumberFormField.propTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Text to appear above form control and to the right of the label. */
  description: PropTypes.string,

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};
